import { render } from "./tarjetaTitular.vue?vue&type=template&id=d5817238"
import script from "./tarjetaTitular.vue?vue&type=script&lang=js"
export * from "./tarjetaTitular.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proyectos\\Front_IOSEP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__